<template>
  <div
      v-loading="loading"
      class="order-return-summary flex flex-auto flex-col">
    <div class="title">
      Replacement #{{ replacementId }} has been created.
    </div>
    <br><br>
    <div 
        v-if="needsReturnLabel"
        class="description">
      Replacement has been created. Customer will receive 2 emails, 1) <br>
      replacement device confirmation and shipping info, and 2) a return label<br>
      to return their old device.
    </div>
    <div
        v-else
        class="description">
      Replacement has been created. Customer will receive an email for replacement device confirmation and shipping info.
    </div>
      
    <br>
    <div class="return-summary">
      <div class="return-customer-details">
        <el-card
            shadow="never"
            body-style="margin: 0px !important;">
          <el-table
              :data="summary"
              :show-header="false"
              class="table-hover"
              row-class-name="table-hover"
              cell-class-name="table-hover"
              :highlight-current-row="false"
              style="width: 100%">
            <el-table-column
                type="expand">
              <template>
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Created On: {{ createdOn }}
                  </div>
                  <br>
                </div>
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Old Product
                  </div>
                  <div style="margin-top: 8px;">
                    {{ device.profile.product.description }}<br>
                    <p style="color: #6E6E6E; margin: 0 !important;">
                      MAC ID: {{ device.mac_address }}
                    </p>
                    <p style="color: #6E6E6E; margin: 0 !important;">
                      {{ device.profile.color }}
                    </p>
                  </div>
                </div>
                <el-divider />
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Replacement Product
                  </div>
                  <div style="margin-top: 8px;">
                    {{ replacementProduct.product.description }}<br>
                    <p style="color: #6E6E6E; margin: 0 !important;">
                      {{ replacementProduct.color }}
                    </p>
                    <p
                        v-if="replacementProduct.estimated_delivery"
                        class="estimated-delivery"
                        style="margin: 0 !important;">
                      {{ replacementProduct.estimated_delivery }}
                    </p>
                  </div>
                </div>
                <el-divider />
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Replacement Reason
                  </div>
                  <div style="margin-top: 8px;">
                    {{ selectedName }}<br>
                  </div>
                </div>
                <el-divider />
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Other Info
                  </div>
                  <div
                      class="flex flex-row"
                      style="margin-top: 8px;">
                    <div class="flex-1">
                      Place of purchase
                    </div>
                    <div>{{ retailer }}</div>
                  </div>
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Date of initial setup
                    </div>
                    <div>
                      <time-zone-formatter
                          output-format="DD MMMM, YYYY"
                          :current-time="firstSetupDate" />
                    </div>
                  </div>
                </div>
                <el-divider />
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Customer info
                  </div><br>
                </div>
                <div class="flex flex-col">
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Name
                    </div>
                    <div>{{ customer.first_name }} {{ customer.last_name }}</div>
                  </div>
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Phone Number
                    </div>
                    <div>{{ customer.phone_number }}</div>
                  </div>
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Email
                    </div>
                    <div>{{ customer.email }}</div>
                  </div>
                  <div
                      class="flex flex-row"
                      style="margin-top: 20px">
                    <div class="flex-1">
                      Street
                    </div>
                    <div>{{ address.address1 }} {{ address.address2 }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      City
                    </div>
                    <div>{{ address.city }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      State/province/area
                    </div>
                    <div>{{ address.state }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      Zip code
                    </div>
                    <div>{{ address.zip_code }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      Country
                    </div>
                    <div>{{ address.country }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                label="Replacement Summary"
                prop="title"
                style="padding-left: 20px;" /><label>Replacement Summary
                </label>
          </el-table>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from "numeral";
import axios from "axios";

export default {
  name: "ReplacementSummary",
  props: {
    firstSetupDate: {
      type: String,
      default: "",
    },
    device: {
      type: Object,
      required: true,
    },
    replacementProduct: {
      type: Object,
      required: true,
    },
    selectedName: {
      type: String,
      default: "",
    },
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          first_name: "",
          last_name: "",
          phone_number: "",
          email: "",
        };
      },
    },
    address: {
      type: Object,
      required: true,
      default() {
        return {
          address1: "",
          address2: "",
          city: "",
          state: "",
          zip_code: "",
          country: "",
        };
      },
    },
    replacementId: {
      type: String,
      required: true,
      default: "",
    },
    createdOn: {
      type: String,
      required: true,
      default: "",
    },
    needsReturnLabel: {
      type: Boolean,
      required: false,
      default: true, // Optional prop, defaults to null if not passed
    },
  },
  data() {
    return {
      summary: [
        {
          type: "expand",
          title: "Replacement Summary",
        },
      ],
      loading: false,
    };
  },
  watch: {},
  methods: {},
};
</script>

<style>
.order-return-summary {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }

  .return-details {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 10px;
    color: #424242;
  }

  .estimated-delivery {
    color: var(--light-content-backup, #6e6e6e);
    font-family: Equip;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .edit-details-link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    text-decoration-line: underline;
    color: #1476ad;
  }
}
.return-summary {
  .summary-header {
    width: 939px;
    height: 24px;

    /* body/large-medium */

    font-family: "Equip";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    display: flex;
    align-items: flex-end;

    /* 🖥 light/content/base */

    color: #424242;

    /* Inside auto layout */

    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }

  .el-table__expanded-cell[class*="cell"] {
    padding: 24px 48px 40px 72px !important;
    line-height: initial;
  }

  .el-table td.el-table__cell div {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: inherit !important;
  }
  .el-icon::before {
    height: 32px !important;
    width: 32px !important;
  }
  .el-table .cell {
    padding-left: 24px;
  }
  .el-table__expand-icon > .el-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -24px;
    margin-top: -13px;
  }
  .el-table__expand-icon > .el-icon {
    font-size: 32px !important;
    -webkit-transform: rotate(90deg) !important;
    transform: rotate(90deg) !important;
  }
}
</style>
